import moment from "moment/moment"

export const POST_MODEL = {
  postType: 1,
  copy: "",
  title: "",
  topic: "",
  description: "",
  content: "",
  link: "",
  cover: "",
  user: "cipcdlima",
  coin: 1,
  price: 0.0,
  scope: 1,
  scopeLimitedTo: "",
  startDate: moment().format("YYYY-MM-DD"),
  finishDate: moment().format("YYYY-MM-DD"),
  state: 1,
  insertionUser: "",
}

export const USER_MODEL = {
  id: "",
  password: "",
  changedPassword: "N",
  verifiedAccount: "N",
  role: 3,
  accessLevel: 5,
  personType: 2,
  name: "",
  surname: "",
  businessName: "",
  ruc: "",
  phone: "",
  email: "",
  web: "",
  cover: "",
  color: 1,
  chapter: "00",
  notificationToken: "",
  verificationToken: "",
  state: 1,
  insertionUser: "",
}

export const TRANSACTION_MODEL = {
  user: "",
  transactionType: "",
  coin: 1,
  total: 0.0,
  payload: "",
  response: "",
  providerId: "",
  paymentMethod: "",
  cpeType: "",
  cpeSeries: "",
  cpeNumber: "",
  tracking: 2,
  state: 1,
  insertionUser: "",
}

export const SESSION_MODEL = {
  user: "",
  host: "",
  insertionDate: "",
}
